import { firebaseDatabase } from '../utils/firebaseUtils'

export default class FirebaseService {
  static addLog = (path, object) => {
    const ref = firebaseDatabase.ref(path).push();
    const id = firebaseDatabase.ref(path).push().key;
    ref.set(object);
    return id;
  };
}